import Loading from 'vue-loading-overlay'
import axios from 'axios'
import * as config from '@/config.json'
import moment from 'moment'
import NotFound from '../../components/NotFound.vue'

export default {
  name: 'MonitoringView',
  components: {
    Loading,
    NotFound
  },
  data: () => {
    return {
      isLoading: false,
      token: null,
      selectedFilterOption: '',
      posId: 0,
      recognitionDeviceId: 0,
      serieName: '',
      serieStartDate: '',
      serieEndDate: '',
      serieNameRecognitionDevice: '',
      serieStartDateRecognitionDevice: '',
      serieEndDateRecognitionDevice: '',
      detailsAlertComplete: [],
      detailsAlert: [],
      fieldsDetailsAlert: [
        {
          key: 'data',
          label: 'Data'
        },
        {
          key: 'status',
          label: 'Status'
        },
        {
          key: 'operation',
          label: 'Operação'
        },
        {
          key: 'battery',
          label: 'Bateria'
        },
        {
          key: 'memory',
          label: 'Memória'
        },
        {
          key: 'connectivity',
          label: 'Conectividade'
        }
      ],

      perPageAlert: 8,
      totalRegisters: 0,
      totalRegistersRecognitionDevices: 0,
      totalRecognitionDevices: 0,
      totalPos: 0,
      filterOptions: [
        {
          value: '',
          text: 'Data'
        },
        {
          value: '1',
          text: 'Ultimas 24 Horas'
        }
      ],
      date: moment().format('YYYY-MM-DD'),

      chartOptionsMobile: {
        chart: {
          height: 400,
          width: '100%',
          type: 'rangeBar',
          animations: {
            enabled: false,
            easing: 'linear',
            speed: 10,
            animateGradually: {
              enabled: false,
              delay: 10
            },
            dynamicAnimation: {
              enabled: true,
              speed: 10
            }
          },
          zoom: {
            enabled: false
          }
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '100%',
            rangeBarGroupRows: true
          }
        },
        colors: ['#0B6327', '#CB0000', '#FFD500'],
        grid: {
          xaxis: {
            lines: {
              show: false
            }
          },
          yaxis: {
            lines: {
              show: true
            }
          }
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'light',
            type: 'vertical',
            shadeIntensity: 0.5,
            gradientToColors: undefined,
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1
          }
        },
        yaxis: {
          show: true,
          labels: {
            show: true,
            align: 'left',
            minWidth: 0,
            maxWidth: 150,
            style: {
              colors: [],
              fontSize: '10px',
              fontFamily: 'Helvetica, Arial, sans-serif',
              fontWeight: 500,
              cssClass: 'apexcharts-yaxis-label'
            },
            offsetX: -5,
            offsetY: 0,
            rotate: 0,
            formatter: function (value) {
              if (!value || typeof value !== 'string') return value

              // Quebra texto em múltiplas linhas
              const maxLength = 20
              if (value.length <= maxLength) return value

              const words = value.split(' ')
              let lines = []
              let currentLine = ''

              words.forEach(word => {
                if ((currentLine + ' ' + word).trim().length <= maxLength) {
                  currentLine += (currentLine ? ' ' : '') + word
                } else {
                  if (currentLine) lines.push(currentLine.trim())
                  currentLine = word
                }
              })

              if (currentLine) lines.push(currentLine.trim())

              return lines.length > 1 ? lines : value
            }
          }
        },
        xaxis: {
          type: 'datetime',
          labels: {
            style: {
              fontSize: '10px'
            }
          }
        },
        tooltip: {
          x: {
            show: false,
            format: 'HH:mm:ss'
          },
          style: {
            fontSize: '10px',
            fontFamily: undefined,
            color: 'silver'
          },
          fixed: {
            enabled: true,
            position: 'topRight',
            offsetX: -120,
            offsetY: -30
          }
        },
        dataLabels: {
          enabled: false
        }
      },

      chartOptionsRecognitionDevicesMobile: {
        chart: {
          height: 400,
          width: '100%',
          type: 'rangeBar',
          animations: {
            enabled: false,
            easing: 'linear',
            speed: 10,
            animateGradually: {
              enabled: false,
              delay: 10
            },
            dynamicAnimation: {
              enabled: true,
              speed: 10
            }
          },
          zoom: {
            enabled: false
          }
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '100%',
            rangeBarGroupRows: true,
            fillColors: ['#0B6327', '#CB0000', '#FFD500']
          }
        },
        colors: ['#0B6327', '#CB0000', '#FFD500'],
        grid: {
          xaxis: {
            lines: {
              show: false
            }
          },
          yaxis: {
            lines: {
              show: true
            }
          }
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'light',
            type: 'vertical',
            shadeIntensity: 0.5,
            gradientToColors: undefined,
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1
          }
        },
        yaxis: {
          show: true,
          labels: {
            show: true,
            align: 'left',
            minWidth: 0,
            maxWidth: 150,
            style: {
              colors: [],
              fontSize: '10px',
              fontFamily: 'Helvetica, Arial, sans-serif',
              fontWeight: 500,
              cssClass: 'apexcharts-yaxis-label'
            },
            offsetX: -5,
            offsetY: 0,
            rotate: 0,
            formatter: function (value) {
              if (!value || typeof value !== 'string') return value

              // Quebra texto em múltiplas linhas
              const maxLength = 20
              if (value.length <= maxLength) return value

              const words = value.split(' ')
              let lines = []
              let currentLine = ''

              words.forEach(word => {
                if ((currentLine + ' ' + word).trim().length <= maxLength) {
                  currentLine += (currentLine ? ' ' : '') + word
                } else {
                  if (currentLine) lines.push(currentLine.trim())
                  currentLine = word
                }
              })

              if (currentLine) lines.push(currentLine.trim())

              return lines.length > 1 ? lines : value
            }
          }
        },
        xaxis: {
          type: 'datetime',
          labels: {
            style: {
              fontSize: '10px'
            }
          }
        },
        tooltip: {
          x: {
            show: false,
            format: 'HH:mm:ss'
          },
          style: {
            fontSize: '10px',
            fontFamily: undefined,
            color: 'silver'
          },
          fixed: {
            enabled: true,
            position: 'topRight',
            offsetX: -120,
            offsetY: -30
          }
        },
        dataLabels: {
          enabled: false
        }
      },

      chartOptions: {
        chart: {
          height: 500,
          width: '100%',
          type: 'rangeBar',

          animations: {
            enabled: false,
            easing: 'linear',
            speed: 10,

            animateGradually: {
              enabled: false,
              delay: 10
            },
            dynamicAnimation: {
              enabled: true,
              speed: 10
            }
          },

          zoom: {
            enabled: false
          }
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '100%',
            rangeBarGroupRows: true
          }
        },
        colors: ['#0B6327', '#CB0000', '#FFD500'],
        grid: {
          xaxis: {
            lines: {
              show: false
            }
          },
          yaxis: {
            lines: {
              show: true
            }
          }
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'light',
            type: 'vertical',
            shadeIntensity: 0.5,
            gradientToColors: undefined,
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1
          }
        },
        yaxis: {
          show: true,
          labels: {
            show: true,

            align: 'left',
            minWidth: 0,
            maxWidth: 600,
            style: {
              colors: [],
              fontSize: '14px',
              fontFamily: 'Helvetica, Arial, sans-serif',
              fontWeight: 500,
              cssClass: 'apexcharts-yaxis-label'
            },
            offsetX: -10,
            offsetY: 0,
            rotate: 0,
            height: 15

            // formatter: value => {
            //   try {
            //     const index = value.indexOf('|')
            //     if (index >= 0) {
            //       return value.split('|')
            //     }
            //   } catch (error) {
            //     return value
            //   }
            // }
          }
        },
        xaxis: {
          type: 'datetime'
        },
        tooltip: {
          x: {
            show: false,
            format: 'HH:mm:ss'
          },
          style: {
            fontSize: '12px',
            fontFamily: undefined,
            color: 'silver'
          },
          fixed: {
            enabled: true,
            position: 'topRight',
            offsetX: -240,
            offsetY: -30
          }
        },
        dataLabels: {
          enabled: true,
          formatter: value => {
            try {
              const index = value.indexOf('|')
              if (index >= 0) {
                return value.split('|')
              }
            } catch (error) {
              return value
            }
          }
        }
      },

      chartOptionsRecognitionDevices: {
        chart: {
          height: 500,
          width: '100%',
          type: 'rangeBar',

          animations: {
            enabled: false,
            easing: 'linear',
            speed: 10,

            animateGradually: {
              enabled: false,
              delay: 10
            },
            dynamicAnimation: {
              enabled: true,
              speed: 10
            }
          },

          zoom: {
            enabled: false
          }
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '100%',
            rangeBarGroupRows: true,
            fillColors: ['#0B6327', '#CB0000', '#FFD500']
          }
        },
        colors: ['#0B6327', '#CB0000', '#FFD500'],
        grid: {
          xaxis: {
            lines: {
              show: false
            }
          },
          yaxis: {
            lines: {
              show: true
            }
          }
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'light',
            type: 'vertical',
            shadeIntensity: 0.5,
            gradientToColors: undefined,
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1
          }
        },
        yaxis: {
          show: true,
          labels: {
            show: true,

            align: 'left',
            minWidth: 0,
            maxWidth: 600,
            style: {
              colors: [],
              fontSize: '14px',
              fontFamily: 'Helvetica, Arial, sans-serif',
              fontWeight: 500,
              cssClass: 'apexcharts-yaxis-label'
            },
            offsetX: -10,
            offsetY: 0,
            rotate: 0,
            height: 15

            // formatter: value => {
            //   try {
            //     const index = value.indexOf('|')
            //     if (index >= 0) {
            //       return value.split('|')
            //     }
            //   } catch (error) {
            //     return value
            //   }
            // }
          }
        },
        xaxis: {
          type: 'datetime'
        },
        tooltip: {
          x: {
            show: false,
            format: 'HH:mm:ss'
          },
          style: {
            fontSize: '12px',
            fontFamily: undefined,
            color: 'silver'
          },
          fixed: {
            enabled: true,
            position: 'topRight',
            offsetX: -240,
            offsetY: -30
          }
        },

        dataLabels: {
          enabled: true,
          formatter: value => {
            try {
              const index = value.indexOf('|')
              if (index >= 0) {
                return value.split('|')
              }
            } catch (error) {
              return value
            }
          }
        }
      },

      series: [],
      seriesActive: [],
      seriesInactive: [],
      seriesWarning: [],

      seriesRecognitionDevices: [],
      seriesActiveRecognitionDevices: [],
      seriesInactiveRecognitionDevices: [],
      seriesWarningRecognitionDevices: [],

      notFoundMessage: '',
      notFoundMessageRecognitionDevices: '',
      show: false,
      showRecognitionDevices: false,

      optionsSites: [],
      selectedOptionSites: null,
      tabIndex: 0,
      posStatusComplete: [],
      recognitionDevicesStatusComplete: [],
      posStatus: [],
      recognitionDevicesStatus: [],
      posStatusFiltered: [],
      recognitionDevicesStatusFiltered: [],
      fieldsPosStatus: [
        { key: 'pos', label: 'POS' },
        { key: 'loja', label: 'Loja' },
        { key: 'data', label: 'Data' },
        { key: 'operacao', label: 'Operação' },
        { key: 'status', label: 'Status' },
        { key: 'bateria', label: 'Bateria' },
        { key: 'memoria', label: 'Memória' },
        { key: 'conectividade', label: 'Conectividade' }
      ],
      fieldsRecognitionDevicesStatus: [
        { key: 'loja', label: 'Loja' },
        { key: 'data', label: 'Data' },
        { key: 'status', label: 'Status' },
        { key: 'operacao', label: 'Operação' },
        { key: 'bateria', label: 'Bateria' },
        { key: 'memoria', label: 'Memória' },
        { key: 'conectividade', label: 'Conectividade' }
      ],
      hasPosStatus: false,
      hasRecognitionDevicesStatus: false,
      optionsStatusPOS: [],
      selectedOptionsStatusPOS: null,
      optionsStatusRecognitionDevices: [],
      selectedOptionsStatusRecognitionDevices: null,
      siteNamePOS: '',
      siteNameRecognitionDevices: '',
      posIds: [],
      recognitionDevicesIds: []
    }
  },
  methods: {
    async clearLocalStorage() {
      localStorage.removeItem('siteIdMonitoringSite')
    },

    async redirect(ref) {
      await this.clearLocalStorage()
      this.$router.push(ref)
    },

    updatePage() {
      this.$router.go()
    },

    async cleanSearch() {
      this.selectedOptionSites = null

      await this.updateChart()
      await this.updateChartRecognitionDevices()
    },

    async dataPointSelection(event, chartContext, config) {
      const serie = config.w.config.series
      const index = config.seriesIndex
      const dataPointIndex = config.dataPointIndex

      const serieMounted = serie[index].data[dataPointIndex]

      this.serieName = serieMounted.x
      this.posId = serieMounted.posId
      this.serieStartDate = serieMounted.startDate
      this.serieEndDate = serieMounted.endDate

      const posId = new Array(`${this.posId}`)
      await this.getDetails(posId, this.serieStartDate, this.serieEndDate)
    },

    async dataPointRecognitionDevicesSelection(event, chartContext, config) {
      const serie = config.w.config.series
      const index = config.seriesIndex
      const dataPointIndex = config.dataPointIndex

      const serieMounted = serie[index].data[dataPointIndex]

      this.serieNameRecognitionDevice = serieMounted.x
      this.recognitionDeviceId = serieMounted.recognitionDevicesId
      this.serieStartDateRecognitionDevice = serieMounted.startDate
      this.serieEndDateRecognitionDevice = serieMounted.endDate

      const recognitionDeviceId = new Array(`${this.recognitionDeviceId}`)

      await this.getRecognitionDeviceDetails(recognitionDeviceId, this.serieStartDateRecognitionDevice, this.serieEndDateRecognitionDevice)
    },

    async getNotification(title, body, type) {
      this.$vToastify.setSettings({
        position: 'bottom-center'
      })
      await this.$vtNotify({
        title: title,
        body: body,
        type: type,
        duration: 3000
      })
    },

    async builtData(option, siteId) {
      const data = {}

      if (option == '1') {
        data.filterType = 'last24Hours'
      }

      if (option == '') {
        data.filterType = 'date'
        data.date = moment(this.date).format('YYYY-MM-DD')
      }

      if (siteId) {
        data.siteId = siteId
      }

      return data
    },

    async changeDate() {
      if (this.selectedFilterOption == '1') {
        await this.updateChart()
        await this.updateChartRecognitionDevices()

        return
      }

      const today = moment(new Date()).format('YYYY-MM-DD')
      if (this.date > today) {
        this.series = []
        this.seriesRecognitionDevices = []
        return await this.getNotification('Aviso', `A data escolhida deve ser menor ou igual à ${today}!`, 'warning')
      }

      await this.updateChart()
      await this.updateChartRecognitionDevices()
    },

    buildDataAllDetails(posIds, dateType, date) {
      const data = {
        posId: posIds
      }

      if (dateType == '1') {
        data.startDate = moment(Date.now()).subtract(24, 'hours').format('YYYY-MM-DD 00:00:00')
        data.endDate = moment(Date.now()).format('YYYY-MM-DD 23:59:59')
        data.filterType = 'last24Hours'
      } else {
        data.startDate = moment(date).format('YYYY-MM-DD 00:00:00')
        data.endDate = moment(date).format('YYYY-MM-DD 23:59:59')
        data.filterType = 'date'
      }

      return data
    },

    buildDataAllRecognitionDevicesDetails(recognitionDevicesIds, dateType, date) {
      const data = {
        recognitionDeviceId: recognitionDevicesIds
      }

      if (dateType == '1') {
        data.startDate = moment(Date.now()).subtract(24, 'hours').format('YYYY-MM-DD 00:00:00')
        data.endDate = moment(Date.now()).format('YYYY-MM-DD 23:59:59')
        data.filterType = 'last24Hours'
      } else {
        data.startDate = moment(date).format('YYYY-MM-DD 00:00:00')
        data.endDate = moment(date).format('YYYY-MM-DD 23:59:59')
        data.filterType = 'date'
      }

      return data
    },

    async getAllDetails(posIds, dateType, date) {
      // Evitar chamadas desnecessárias se não há IDs
      if (!posIds || posIds.length === 0) {
        this.hasPosStatus = false
        return
      }

      this.isLoading = true

      try {
        const url = `${config.default.urlBase}/sites/pos/status/details`
        const data = this.buildDataAllDetails(posIds, dateType, date)

        const response = await axios({
          url,
          method: 'POST',
          data,
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.isLoading = false

          this.hasPosStatus = true

          this.posStatusComplete = response.data

          let mountedPosStatus = []
          let mountedDuplicatedStatus = []

          await Promise.all(
            this.posStatusComplete.map(item => {
              mountedPosStatus.push({
                pos: item.posNumber,
                loja: item.siteName,
                data: item.createdAt,
                operacao: item.status.operation,
                status: item.status.message,
                bateria: item.status.battery,
                memoria: item.status.memory,
                conectividade: item.status.connectivity
              })
              mountedDuplicatedStatus.push(item.status.message)
            })
          )

          const uniqueStatus = [...new Set(mountedDuplicatedStatus)]

          this.optionsStatusPOS = await Promise.all(
            uniqueStatus.map((item, index) => {
              return {
                value: index,
                text: item
              }
            })
          )

          this.posStatus = []
          this.posStatus = mountedPosStatus
          this.posStatusFiltered = mountedPosStatus
          this.siteNamePOS = response.data[0]?.siteName || ''
        }
      } catch (error) {
        console.error('Error in getAllDetails:', error)

        this.isLoading = false

        this.hasPosStatus = false

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        }

        if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else if (error.response.status == 404) {
          // Não exibir alerta para 404, apenas definir hasPosStatus como false
          this.hasPosStatus = false
        }
      }
    },

    async getAllDetailsRecognitionDevices(recognitionDevicesIds, dateType, date) {
      // Evitar chamadas desnecessárias se não há IDs
      if (!recognitionDevicesIds || recognitionDevicesIds.length === 0) {
        this.hasRecognitionDevicesStatus = false
        return
      }

      this.isLoading = true

      try {
        const url = `${config.default.urlBase}/sites/recognition-devices/status/details`
        const data = this.buildDataAllRecognitionDevicesDetails(recognitionDevicesIds, dateType, date)

        const response = await axios({
          url,
          method: 'POST',
          data,
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.isLoading = false

          this.hasRecognitionDevicesStatus = true

          this.recognitionDevicesStatusComplete = response.data

          let mountedPosStatus = []
          let mountedDuplicatedStatus = []
          await Promise.all(
            this.recognitionDevicesStatusComplete.map(item => {
              mountedPosStatus.push({
                loja: item.siteName,
                data: item.createdAt,
                status: item.status.message,
                operacao: item.status.operation,
                bateria: item.status.battery,
                memoria: item.status.memory,
                conectividade: item.status.connectivity
              })
              mountedDuplicatedStatus.push(item.status.message)
            })
          )

          const uniqueStatus = [...new Set(mountedDuplicatedStatus)]

          this.optionsStatusRecognitionDevices = await Promise.all(
            uniqueStatus.map((item, index) => {
              return {
                value: index,
                text: item
              }
            })
          )

          this.recognitionDevicesStatus = []
          this.recognitionDevicesStatus = mountedPosStatus
          this.recognitionDevicesStatusFiltered = mountedPosStatus
          this.siteNameRecognitionDevices = response.data[0]?.siteName || ''
        }
      } catch (error) {
        console.error('Error in getAllDetailsRecognitionDevices:', error)

        this.isLoading = false

        this.hasRecognitionDevicesStatus = false

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        }

        if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else if (error.response.status == 404) {
          // Não exibir alerta para 404, apenas definir hasRecognitionDevicesStatus como false
          this.hasRecognitionDevicesStatus = false
        } else {
          await this.$alert(`Ocorreu um erro atualizar o status do monitoramento! ${error.response.data.message}`, 'Aviso', 'warning')
        }
      }
    },

    async cleanOptionsPOSStatus() {
      this.selectedOptionsStatusPOS = null
      if (this.tabIndex === 0) {
        this.posStatusFiltered = this.posStatus
      } else if (this.tabIndex === 1) {
        this.recognitionDevicesStatusFiltered = this.recognitionDevicesStatus
      }
    },

    async cleanOptionsRecognitionDevicesStatus() {
      this.selectedOptionsStatusRecognitionDevices = null
      this.recognitionDevicesStatusFiltered = this.recognitionDevicesStatus
    },

    async filterPOSStatus(selectedOptionsStatusPOS) {
      const optionsStatus = this.optionsStatusPOS

      const status = optionsStatus[selectedOptionsStatusPOS]?.text

      if (this.tabIndex === 0) {
        // Filtro para aba POS
        this.posStatusFiltered = this.posStatus.filter(item => item.status == status)
      } else if (this.tabIndex === 1) {
        // Filtro para aba Reconhecimento Facial
        this.recognitionDevicesStatusFiltered = this.recognitionDevicesStatus.filter(item => item.status == status)
      }
    },

    async filterRecognitionDevicesStatus(selectedOptionsStatusRecognitionDevices) {
      const optionsStatus = this.optionsStatusRecognitionDevices
      const status = optionsStatus[selectedOptionsStatusRecognitionDevices]?.text
      this.recognitionDevicesStatusFiltered = this.recognitionDevicesStatus.filter(item => item.status == status)
    },

    async getDetails(posId, serieStartDate, serieEndDate) {
      this.isLoading = true

      try {
        const url = `${config.default.urlBase}/sites/pos/status/details`
        const data = {
          posId: posId,
          startDate: moment(serieStartDate).format('YYYY-MM-DD HH:mm:ss'),
          endDate: moment(serieEndDate).format('YYYY-MM-DD HH:mm:ss'),
          filterType: 'date'
        }

        const response = await axios({
          url,
          method: 'POST',
          data,
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.isLoading = false

          this.detailsAlertComplete = response.data

          this.detailsAlert = await Promise.all(
            this.detailsAlertComplete.map(item => {
              return {
                data: item.createdAt,
                operação: item.status.operation,
                status: item.status.message,
                battery: item.status.battery,
                memory: item.status.memory,
                connectivity: item.status.connectivity,
                operation: item.status.operation
              }
            })
          )

          // Se não há dados, não exibir alerta, apenas mostrar o modal vazio
          if (this.detailsAlert.length === 0) {
            this.$bvModal.show('detailsAlert')
          } else {
            this.$bvModal.show('detailsAlert')
          }
        }
      } catch (error) {
        console.error('Error in getDetails:', error)

        this.isLoading = false

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        }

        if (error.response.status == 500) {
          await this.$alert('Ocorreu um erro interno ao buscar os dados do monitoramento!', 'Erro', 'error')
        }

        if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else if (error.response.status == 404) {
          // Não exibir alerta para 404, apenas mostrar modal vazio
          this.detailsAlert = []
          this.$bvModal.show('detailsAlert')
        } else {
          await this.$alert(`Ocorreu um erro ao atualizar o status do monitoramento! ${error.response.data.message}`, 'Aviso', 'warning')
        }
      }
    },

    async getRecognitionDeviceDetails(recognitionDeviceId, serieStartDate, serieEndDate) {
      this.isLoading = true

      try {
        const url = `${config.default.urlBase}/sites/recognition-devices/status/details`
        const data = {
          recognitionDeviceId: recognitionDeviceId,
          startDate: moment(serieStartDate).format('YYYY-MM-DD HH:mm:ss'),
          endDate: moment(serieEndDate).format('YYYY-MM-DD HH:mm:ss'),
          filterType: 'date'
        }

        const response = await axios({
          url,
          method: 'POST',
          data,
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.isLoading = false

          this.detailsAlertComplete = response.data

          this.detailsAlert = await Promise.all(
            this.detailsAlertComplete.map(item => {
              return {
                data: item.createdAt,
                operation: item.status.operation,
                status: item.status.message,
                battery: item.status.battery,
                memory: item.status.memory,
                connectivity: item.status.connectivity
              }
            })
          )

          // Se não há dados, não exibir alerta, apenas mostrar o modal vazio
          if (this.detailsAlert.length === 0) {
            this.$bvModal.show('detailsAlert')
          } else {
            this.$bvModal.show('detailsAlert')
          }
        }
      } catch (error) {
        console.error('Error in getRecognitionDeviceDetails:', error)

        this.isLoading = false

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        }

        if (error.response.status == 500) {
          await this.$alert('Ocorreu um erro interno ao buscar os dados do monitoramento!', 'Erro', 'error')
        }

        if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else if (error.response.status == 404) {
          // Não exibir alerta para 404, apenas mostrar modal vazio
          this.detailsAlert = []
          this.$bvModal.show('detailsAlert')
        } else {
          await this.$alert(`Ocorreu um erro ao atualizar o status do monitoramento! ${error.response.data.message}`, 'Aviso', 'warning')
        }
      }
    },

    async getSitesByUserType() {
      this.isLoading = true

      const url = `${config.default.urlBase}/sites/user/type`

      try {
        const response = await axios({
          url,
          method: 'get',
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.isLoading = false

          this.optionsSites = await Promise.all(
            response.data.map(item => {
              return {
                value: item.id,
                text: `${item.id} ${item.name}`
              }
            })
          )

          if (this.optionsSites.length == 1) {
            this.selectedOptionSites = this.optionsSites[0].value
          }
        }
      } catch (error) {
        console.error('Error in getSitesByUserType:', error)

        this.isLoading = false

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        }

        if (error.response.status == 500) {
          await this.$alert('Ocorreu um erro interno ao buscar os dados do monitoramento!', 'Erro', 'error')
        }

        if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else if (error.response.status == 404) {
          this.getNotification('Aviso', `${error.response.data.message}`, 'warning')
        } else {
          await this.$alert(`Ocorreu um erro ao buscar as empresas! ${error.response.data.message}`, 'Aviso', 'warning')
        }
      }
    },

    async handleUpdate() {
      await this.updateChart()
      await this.updateChartRecognitionDevices()
    },

    async updateChartRecognitionDevices() {
      this.isLoading = true
      this.hasRecognitionDevicesStatus = false
      const url = `${config.default.urlBase}/sites/recognition-devices/status`
      const data = await this.builtData(this.selectedFilterOption, this.selectedOptionSites)

      try {
        const response = await axios({
          url,
          method: 'POST',
          data,
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status === 200) {
          this.isLoading = false

          this.totalRecognitionDevices = response.data.recognitionDevicesIds.length
          this.seriesRecognitionDevices = response.data.timeLine
          this.seriesActiveRecognitionDevices = this.seriesRecognitionDevices[0].data
          this.seriesInactiveRecognitionDevices = this.seriesRecognitionDevices[1].data
          this.seriesWarningRecognitionDevices = this.seriesRecognitionDevices[2].data

          this.totalRegistersRecognitionDevices =
            this.seriesActiveRecognitionDevices.length + this.seriesInactiveRecognitionDevices.length + this.seriesWarningRecognitionDevices.length

          if (
            this.seriesActiveRecognitionDevices.length <= 0 &&
            this.seriesInactiveRecognitionDevices.length <= 0 &&
            this.seriesWarningRecognitionDevices.length <= 0
          ) {
            this.notFoundMessageRecognitionDevices = 'Nenhum Dispositivo de Reconhecimento foi identificado !'
            this.showRecognitionDevices = true
          }

          this.recognitionDevicesIds = response.data.recognitionDevicesIds

          const recognigionDevicesIds = new Array(this.recognitionDevicesIds.join(','))
          this.getAllDetailsRecognitionDevices(recognigionDevicesIds, this.selectedFilterOption, this.date)
        } else {
          this.show = false
        }
      } catch (error) {
        console.error('Error in updateChartRecognitionDevices:', error)

        this.isLoading = false
        this.seriesRecognitionDevices = []
        this.showRecognitionDevices = false

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        }

        if (error.response.status == 500) {
          await this.$alert('Ocorreu um erro interno ao buscar os dados do monitoramento!', 'Erro', 'error')
        }

        if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else if (error.response.status == 404) {
          this.getNotification('Aviso', `${error.response.data.message}`, 'warning')
        } else {
          await this.$alert(`Ocorreu um erro ao atualizar o status do monitoramento! ${error.response.data.message}`, 'Aviso', 'warning')
        }
      }
    },

    async updateChart() {
      this.isLoading = true
      this.hasPosStatus = false
      const url = `${config.default.urlBase}/sites/pos/status`
      const data = await this.builtData(this.selectedFilterOption, this.selectedOptionSites)

      try {
        const response = await axios({
          url,
          method: 'POST',
          data,
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status === 200) {
          this.isLoading = false

          this.totalPos = response.data.posIds.length
          this.series = response.data.timeLine
          this.seriesActive = this.series[0].data
          this.seriesInactive = this.series[1].data
          this.seriesWarning = this.series[2].data

          this.totalRegisters = this.seriesActive.length + this.seriesInactive.length + this.seriesWarning.length

          if (this.seriesActive.length <= 0 && this.seriesInactive.length <= 0 && this.seriesWarning.length <= 0) {
            this.notFoundMessage = 'Nenhum POS foi identificado !'
            this.show = true
          }

          this.posIds = response.data.posIds
          const posIds = new Array(this.posIds.join(','))
          this.getAllDetails(posIds, this.selectedFilterOption, this.date)
        } else {
          this.show = false
        }
      } catch (error) {
        console.error('Error in updateChart:', error)

        this.isLoading = false
        this.series = []
        this.show = false

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        }

        if (error.response.status == 500) {
          await this.$alert('Ocorreu um erro interno ao buscar os dados do monitoramento!', 'Erro', 'error')
        }

        if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else if (error.response.status == 404) {
          this.getNotification('Aviso', `${error.response.data.message}`, 'warning')
        } else {
          await this.$alert(`Ocorreu um erro ao atualizar o status do monitoramento! ${error.response.data.message}`, 'Aviso', 'warning')
        }
      }
    },

    async readSiteParams() {
      if (this.$route.params.siteId) {
        localStorage.setItem('siteIdMonitoringSite', this.$route.params.siteId)
      }

      this.selectedOptionSites = parseInt(localStorage.getItem('siteIdMonitoringSite'))
      await this.updateChart()
      await this.updateChartRecognitionDevices()
      await this.clearLocalStorage()
    }
  },

  watch: {
    tabIndex: {
      handler(newTabIndex, oldTabIndex) {
        // Atualizar os charts e status quando alternar entre abas
        if (newTabIndex !== oldTabIndex) {
          if (newTabIndex === 0) {
            // Aba POS - atualizar chart e status dos POS
            this.updateChart()
          } else if (newTabIndex === 1) {
            // Aba Reconhecimento Facial - atualizar chart e status dos dispositivos de reconhecimento
            this.updateChartRecognitionDevices()
          }
        }
      },
      immediate: false
    }
  },

  computed: {
    computedHeight() {
      const count = this.totalPos
      const minHeight = 150
      const barHeight = 50
      return Math.max(minHeight, count * barHeight)
    },

    computedHeightFacial() {
      const count = this.totalRecognitionDevices
      const minHeightFacial = 150
      const barHeightFacial = 50

      return Math.max(minHeightFacial, count * barHeightFacial)
    },

    showDetailsEmptyMessage() {
      return this.detailsAlert && this.detailsAlert.length === 0 && !this.isLoading
    },

    showRecognitionDetailsEmptyMessage() {
      return this.detailsAlert && this.detailsAlert.length === 0 && !this.isLoading
    },

    showPosStatusEmptyMessage() {
      return this.hasPosStatus === false && !this.isLoading
    },

    showRecognitionDevicesStatusEmptyMessage() {
      return this.hasRecognitionDevicesStatus === false && !this.isLoading
    }
  },

  async beforeMount() {
    this.token = sessionStorage.getItem('token')
    await this.getSitesByUserType()
    await this.readSiteParams()
  }
}
